import { fromJS } from 'immutable'
import filter from './helpers/filterEmpty'

export const isNumber = n => typeof n === 'number' && !isNaN(n)
export const isNegative = n => n < 0
export const unit = n => typeof n === 'number' ? n + 'px' : n
export const merge = (obj, obj2) => fromJS(obj).mergeDeep(obj2).toJS()
export const value = scale => n => (
  isNumber(n) ? unit((scale[Math.abs(n)] || Math.abs(n)) * (isNegative(n) ? -1 : 1)) : n
)
export const filterEmpty = filter
